exports.default = undefined;
const { extend } = require('vee-validate');

// Install rules
_default = extend('phone', {
    validate(value, { country }) {
        let regex;
        switch (country) {
        case 'be':
            regex = /^[0-9]{2}\s[0-9]{3}\s[0-9]{2}\s[0-9]{2}[0-9]?|[0-9]{4}\s[0-9]{2}\s[0-9]{2}\s[0-9]{2}$/;
            break;
        case 'br':
            regex = /^\(?(11|12|13|14|15|16|17|18|19|21|22|24|27|28|31|32|33|34|35|37|38|41|42|43|44|45|46|47|48|49|51|53|54|55|61|62|63|64|65|66|67|68|69|71|73|74|75|77|79|81|82|83|84|85|86|87|88|89|91|92|93|94|95|96|97|98|99)\)?\s?[2-9][0-9]{8,9}$/;
            break;
        case 'co':
            regex = /^([0-9]{7}|[0-9]{10})$/;
            break;
        case 'es':
            regex = /^(6|7|8|9)[0-9]{8}$/;
            break;
        case 'fr':
            regex = /^0[0-9]\s([0-9]{2}\s){3}[0-9]{2}|0[0-9]([0-9]{2}){3}[0-9]{2}$/;
            break;
        case 'it':
            regex = /^(3[0-9]{9}|0[0-9]{5,9})$/;
            break;
        case 'nl':
            regex = /^(?:0|(?:\+|00) ?31 ?)(?:(?:[1-9] ?(?:[0-9] ?){8})|(?:6 ?-? ?[1-9] ?(?:[0-9] ?){7})|(?:[1,2,3,4,5,7,8,9]\d ?-? ?[1-9] ?(?:[0-9] ?){6})|(?:[1,2,3,4,5,7,8,9]\d{2} ?-? ?[1-9] ?(?:[0-9] ?){5}))$/;
            break;
        case 'pt':
            regex = /^(96|92|91|93)\d{7}$/;
            break;
        default:
            regex = /^[0-9]{6,12}$/;
            break;
        }
        return regex.test(value);
    },
    params: ['country'],
});

exports.default = _default;
